import { BaseResponse } from '../manager/handle_data/HandleData';
import { PaginationRequest } from '../types';
import apiService from './api.service';

export interface PackageDataType {
  id: number;
  data?: {
    bannerUrl?: string;
    link?: string;
    type: 'Gói TV360' | 'Gói di động' | 'Gói cố định';
  };
  parentType: 'PACKAGE';
  type: 'Gói TV360' | 'Gói di động' | 'Gói cố định';
}

export type PackageUpsertType = Partial<PackageDataType>;

class PackageService {
  async getAll(params?: PaginationRequest): Promise<BaseResponse<PackageDataType[]>> {
    const paramsReq = {
      parentType: 'PACKAGE',
      ...params,
    };
    const res = await apiService.get('b/sys-config', { params: paramsReq });
    const data = res?.data?.data || [];
    return data;
  }

  async getById(id: string): Promise<BaseResponse<PackageDataType>> {
    const res = await apiService.get(`/b/sys-config/${id}`);
    return res.data;
  }

  async create(data: PackageUpsertType): Promise<BaseResponse<PackageDataType>> {
    const params = {
      parentType: 'PACKAGE',
      ...data,
    };
    const res = await apiService.post('/b/sys-config', params);
    return res.data;
  }

  async update({ id, data }: { id: number; data: PackageUpsertType }): Promise<BaseResponse<PackageDataType>> {
    const params = {
      parentType: 'PACKAGE',
      ...data,
    };
    const res = await apiService.put(`/b/sys-config/${id}`, params);
    return res.data;
  }

  async delete(id: number): Promise<BaseResponse<PackageDataType>> {
    const res = await apiService.delete(`/b/sys-config/${id}`);
    return res.data;
  }
}

const packageService = new PackageService();
export default packageService;
